import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

export const PrevButton = ({ onClick, height }) => {
  const { t } = useTranslation();

  const style =
    height > 0
      ? {
          height,
          top: height / 2,
        }
      : { display: 'none' };

  return (
    <button
      type="button"
      aria-label={t('carousel.previous_button.label')}
      data-e2e="slider-left-button"
      className="ct-videocarousel__buttons ct-videocarousel__prevbutton"
      onClick={onClick}
      style={style}
    >
      <FontAwesomeIcon icon={faAngleLeft} />
    </button>
  );
};

export const NextButton = ({ onClick, height }) => {
  const { t } = useTranslation();

  const style =
    height > 0
      ? {
          height,
          top: height / 2,
        }
      : { display: 'none' };
  return (
    <button
      type="button"
      data-e2e="slider-right-button"
      aria-label={t('carousel.next_button.label')}
      className="ct-videocarousel__buttons ct-videocarousel__nextbutton"
      onClick={onClick}
      style={style}
    >
      <FontAwesomeIcon icon={faAngleRight} />
    </button>
  );
};
